import React from 'react';
import { useFilterContext } from '../../context/aptmetrix/FilterContext';
import { useTooltip } from './useTooltip';
import { handleCommaNumberInput } from './inputHelpers';
import FilterButton from './FilterButton';
import TooltipShell, { FilterActions } from './TooltipShell';

const GapFilter = ({ isOpen, onToggle, onClose, selectedRegion, data, onFilterChange }) => {
    const {
        filterUIState,
        setFilterUIState,
        setGapFilter,
    } = useFilterContext();

    const { minGap, maxGap, isGapFilterActive } = filterUIState;

    const { tooltipRef, buttonRef } = useTooltip(isOpen, onClose);

    const updateUI = (updates) => setFilterUIState(prev => ({ ...prev, ...updates }));
    const setMinGap = (v) => updateUI({ minGap: v });
    const setMaxGap = (v) => updateUI({ maxGap: v });

    const handleToggle = () => {
        if (!selectedRegion) {
            alert('지역을 먼저 선택하세요');
            return;
        }
        onToggle();
    };

    const apply = () => {
        const minVal = minGap ? parseInt(minGap.replace(/,/g, ''), 10) : null;
        const maxVal = maxGap ? parseInt(maxGap.replace(/,/g, ''), 10) : null;
        updateUI({ isGapFilterActive: minVal !== null || maxVal !== null });
        setGapFilter({ minGap: minVal, maxGap: maxVal });
        onFilterChange({ minGap: minVal, maxGap: maxVal });
        onClose();
    };

    const reset = () => {
        updateUI({ minGap: '', maxGap: '', isGapFilterActive: false });
        setGapFilter({ minGap: null, maxGap: null });
        onFilterChange({ minGap: null, maxGap: null });
        onClose();
    };

    const isDisabled = !data || data.length === 0;

    return (
        <div className="relative">
            <FilterButton
                ref={buttonRef}
                label="전매갭"
                activeLabel="전매갭적용"
                isActive={isGapFilterActive}
                isDisabled={isDisabled}
                onClick={handleToggle}
            />
            {isOpen && (
                <TooltipShell ref={tooltipRef} title="전매갭 설정" onClose={onClose}>
                    <div className="flex items-center justify-between mb-3">
                        <input
                            type="text"
                            value={minGap}
                            onChange={(e) => handleCommaNumberInput(e, setMinGap)}
                            placeholder="최소 전매갭"
                            className="w-24 p-1 border border-gray-300 rounded-lg text-center text-sm"
                        />
                        <span className="mx-1">~</span>
                        <input
                            type="text"
                            value={maxGap}
                            onChange={(e) => handleCommaNumberInput(e, setMaxGap)}
                            placeholder="최대 전매갭"
                            className="w-24 p-1 border border-gray-300 rounded-lg text-center text-sm"
                        />
                    </div>
                    <div className="text-xs text-gray-500 mb-2 text-right">(단위: 만원)</div>
                    <FilterActions onReset={reset} onApply={apply} />
                </TooltipShell>
            )}
        </div>
    );
};

export default GapFilter;
